<template>
    <div id="relatedListings" v-if="related.length !== 0">
        <hr class="solid">
        <div class="row">
            <h3 class="mb-3 mt-2" style="margin-bottom: 30px !important;">{{ $t('components.relatedListings.title') }}</h3>
        </div>
        
        <div class="row">
            <div class="col-12">
                <CardCarousel ref="cardCarousel">
                    <div class="col-12 col-md-3" v-for="(lst, index) in related" :key="index" >
                        <ListingCard :listing="lst" class="lstCard"></ListingCard>
                    </div>
                </CardCarousel>
            </div>    
        </div>
    </div>
</template>

<script>
import ListingCard from "@/components/level2/ListingCard"
import CardCarousel from "@/components/common/CardCarousel"
export default {
    name: 'RelatedListings',
    components: {
        ListingCard,
        CardCarousel
    },
    props: {
        forId: {
            type: Number,
            required: true
        }
    },
    watch: {
        forId: function() {
            console.log("forId has changed")
            // When the data changes, update the related listings
        
            this.fetchRelatedListings();
        }
    },
    methods: {
        fetchRelatedListings: function() {
            if (this.isUndefined(this.forId)) {
                return;
            }

            this.$http.get(`listings/${this.forId}/related`)
            .then(res => {
                this.lsts = res.data;
            }).catch(err => {
                console.log(err);
            })
        }
    },
    computed: {
        related: function() {
            const that = this;
            // We need to EXPLICITLY call the hook for the scroller, with a timeout.
            // This is due to the way data is fetched.
            setTimeout(function() {
                if (that.lsts !== undefined && that.lsts.length !== 0) {
                    console.log("Attaching listener");
                    that.$refs.cardCarousel.attachListener();
                }
            }, 200);
            
            return this.lsts
        },
    },
    mounted: function() {
        this.fetchRelatedListings();
    },
    data() {
        return {
            lsts: [],
        }
    }
}
</script>

<style lang="scss" scoped>
    $arrow-size: 30px;

    #scroller {
        width: 100%;
        overflow-x: scroll
    }

    .carouselNav {
        position: absolute;
        bottom: 40%;

        -webkit-transform: translate(-50%,-50%);
        transform: translate(-50%,-50%);

        width: $arrow-size;
        height: $arrow-size;
        background-color: rgba(0,0,0,0.6);
        color: white;
        text-align: center;
        cursor: pointer;

        i {
            cursor: pointer;
        }
    }

    .fa {
        padding-top: 2px;
    }

    .next {
        right: calc(-1 * (#{$arrow-size} / 2) );
    }

    .prev {
        left: calc(#{$arrow-size} / 2);
    }
    
    .lstCard {
        margin: 10px;
    }
</style>